import {
  GLOBAL_SEARCH_URL
} from 'app/utils/Constants';

import {
  get
} from 'app/services/ApiService';

export const globalSearch = async (accountId, query) => {
  return await get(GLOBAL_SEARCH_URL(accountId, query));
}
